\rentware-tabs
    width: 100%
    position: relative
    display: block

.TabsContainer
    position: relative
    width: 100%
    height: 100px
    display: flex
    flex-direction: row
    align-items: center
    justify-content: space-between
    font-size: 12px
    color: rgb($globalSettingsFontPrimary)
    box-sizing: border-box
    overflow: auto
    &.FixedStyle
        color: rgb(70, 70, 91)

    .TabsContainerInner
        position: relative
        min-width: 100%
        height: 100%
        display: flex
        flex-direction: row
        justify-content: flex-start
        flex-shrink: 0
        box-sizing: border-box

    .TabContainer
        height: 100%
        display: flex
        flex-direction: column
        align-items: center
        justify-content: flex-end
        box-sizing: border-box
        cursor: pointer
        transition: opacity 0.8s
        gap: 5px

    .InactiveContainer
        opacity: 0.6
        &:hover
            opacity: 1

    .TabImage
        display: block
        margin: auto
        max-width: 60px
        max-height: 60px
        height: auto
        border-radius: 5px

    .TabTitle
        max-width: 100%
        height: 32px
        line-height: 12px
        font-weight: 400
        overflow: hidden
        padding: 0 2px
        margin-bottom: 5px
        box-sizing: border-box
        display: flex
        align-items: center
        justify-content: center

    .InnerTabTitle
        max-width: 100%
        display: -webkit-box
        -webkit-line-clamp: 2
        -webkit-box-orient: vertical
        text-align: center
        text-overflow: ellipsis
        overflow: hidden
        word-wrap: break-word

    .ActiveTitle
        font-weight: 700

    .ActiveTab
        position: absolute
        left: 0
        bottom: 0
        width: 80px
        height: 4px
        background: rgb($globalCartColorsActiveTab)
        border-radius: 3px
        &.FixedStyle
            background: rgb(42, 173, 186)

.checkoutTabs
    background: linear-gradient(180deg, rgb($globalSettingsBackgroundPrimary) 76.25%, rgb($globalSettingsBackgroundSecondary) 100%), rgb($globalSettingsBackgroundPrimary)

.searchTabs
    transform: translate(0, 2px)

.configTabs
    height: 100%
    padding: 0 15px

@media #{$tablet}
    .checkoutTabs
        width: 640px

    .searchTabs
        max-width: 800px
